const InsightAiMockup = () => (
  <svg viewBox='0 0 400 220' className='w-full h-full' role='img' aria-label='Insight AI support assistant mockup'>
    <defs>
      <linearGradient id='insight-bg' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0%' stopColor='#232526' />
        <stop offset='55%' stopColor='#2c2c6c' />
        <stop offset='100%' stopColor='#0f2027' />
      </linearGradient>
    </defs>
    <rect width='400' height='220' fill='url(#insight-bg)' />

    <rect x='24' y='20' width='140' height='14' rx='4' fill='#fff' opacity='0.9' />
    <circle cx='360' cy='27' r='10' fill='#4db5ff' opacity='0.8' />

    <g transform='translate(24, 54)'>
      <rect width='210' height='30' rx='14' fill='#fff' opacity='0.08' />
      <rect x='14' y='11' width='150' height='8' rx='3' fill='#fff' opacity='0.6' />
    </g>
    <g transform='translate(166, 92)'>
      <rect width='210' height='40' rx='14' fill='#4db5ff' opacity='0.9' />
      <rect x='14' y='10' width='120' height='8' rx='3' fill='#0f2027' opacity='0.8' />
      <rect x='14' y='22' width='80' height='6' rx='3' fill='#0f2027' opacity='0.5' />
    </g>
    <g transform='translate(24, 140)'>
      <rect width='240' height='48' rx='14' fill='#fff' opacity='0.08' />
      <rect x='14' y='10' width='130' height='8' rx='3' fill='#fff' opacity='0.6' />
      <rect x='14' y='22' width='200' height='6' rx='3' fill='#fff' opacity='0.35' />
      <rect x='14' y='32' width='160' height='6' rx='3' fill='#fff' opacity='0.35' />
    </g>

    <g transform='translate(24, 198)'>
      <rect width='352' height='14' rx='7' fill='#fff' opacity='0.1' />
      <circle cx='340' cy='7' r='7' fill='#4db5ff' />
    </g>
  </svg>
)

export default InsightAiMockup
